import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      position="top-center"
      richColors
      expand={true}
      closeButton
      style={{ zIndex: 9999 }}
      toastOptions={{
        style: {
          background: '#1f2937',
          color: '#fff',
          border: '1px solid #374151',
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
